import VirtualMachine from './virtual-machine.js';
import ArgumentType from './extension-support/argument-type';
import BlockType from './extension-support/block-type';

export default VirtualMachine;
export {ArgumentType, BlockType};

export type * as schema from './serialization/schema';
